const toPersianDigits = (value) => {
  const charCodeZero = "۰".charCodeAt(0)
  return String(value).replace(/[0-9]/g, (w) =>
    String.fromCharCode(w.charCodeAt(0) + charCodeZero - 48)
  )
}
const toEnglishDigits = (value) => {
  const charCodeZero = "۰".charCodeAt(0)
  return value.replace(/[۰-۹]/g, (w) => w.charCodeAt(0) - charCodeZero)
}
const toTime = (seconds, format = "00:00") => {
  let temp = seconds
  let string = ""
  let c
  while (temp) {
    c = `0${temp % 60}`.slice(-2)
    temp = Math.floor(temp / 60)
    string = `${c}:${string}`
  }
  string = `${format}:${string}`.substr(-format.length - 1)
  if (string) return toPersianDigits(string.slice(0, -1))
  return 0
}
const putCommas = (str) => str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const toOff = (value) => toEnglishDigits(value).replace(/\D/g, "")
const toOn = (value) => (value ? toPersianDigits(putCommas(value)) : "")

const toOnReduxForm = (value) => value && toOn(toOff(value))

export default {
  toPersianDigits,
  toEnglishDigits,
  toTime,
  putCommas,
  toOff,
  toOn,
  toOnReduxForm,
}
